export enum RoutesUrls {
  root = '/',
  main = '/doo',
  doo = '/doo',
  about = '/about',
  parent = '/parents',
  parentRegistration = '/parent-registration',
  docs = '/docs',
  kindergartens = '/kindergartens',
  kindergartenDetail = '/kindergartens/:id',
  applicationStatus = '/application-status',
  statistics = '/statistics',
  registration = '/registration',
  monDocuments = '/monDocuments',
  monDocumentsSitePage = '/mon-documents',
  monFinanceVoucher = '/mon-finance-voucher',
  monVoucher = '/mon-voucher',
  monHelp = '/mon-help',
  openData = '/openData',
  familyRelation = '/family-relation',
  requiredDocuments = '/required-documents',
  login = '/login',
  mobileAuth = '/mobile-auth',
  authCallback = '/auth/callback',
  esi = '/esi',
  ekyzmat = '/ekyzmat',
  mugalim = '/mugalim',
  recovery = '/recovery',
  resetPassword = '/resetPassword',
  instructionsReference = '/instructions-reference',
  confirmReference = '/confirm-reference',
  logout = '/cabinet/logout',
  cabinet = '/cabinet',
  home = '/cabinet/home',
  personal = '/cabinet/personal',
  ministries = '/cabinet/ministries',
  organization = '/cabinet/organization',
  staff = '/cabinet/staff',
  documents = '/cabinet/documents',
  kids = '/cabinet/kids',
  applications = '/cabinet/applications',
  applicationDetail = '/cabinet/applications/:id',
  group = '/cabinet/group',
  departments = '/cabinet/departments',
  attendance = '/cabinet/attendance',
  attendanceReport = '/cabinet/timesheet',
  training = '/cabinet/training',
  kindergartenVaucher = '/cabinet/voucher',

  parentCabinet = '/parent',
  parentHelp = '/help',
  parentCabinetMembers = '/parent/members',
  parentCabinetHome = '/parent/home',
  parentCabinetPersonal = '/parent/personal',
  parentCabinetEducation = '/parent/education',
  parentCabinetVoucher = '/parent/voucher',
  parentCabinetChildrenList = '/parent/childrens',
  parentCabinetAttendance = '/parent/attendance',
  parentCabinetInstruction = '/parent/instruction',
  parentCabinetPayment = '/parent/payment',
  parentCabinetNotifications = '/parent/notifications',

  // Новые маршруты для заявок родителей
  parentApplicationGov = '/parent/application/gov',
  parentApplicationPrivate = '/parent/application/private',
  parentApplicationShortTerm = '/parent/application/short-term',
  parentApplicationSpecial = '/parent/application/special',
  parentApplicationDepartment = '/parent/application/department',

  siteFaq = '/faq',

  voucher = '/voucher/',
  voucherRegistration = '/voucher/registration',
  voucherFaq = '/voucher/faq',
  voucherAdmin = '/voucher/admin',
  voucherApplication = '/voucher/application',
  voucherApplicationDetail = '/voucher/application/:id',
  voucherCommission = '/voucher/commission',
  voucherAymakAgreement = '/voucher/voucher-aymak-agreement',
  voucherAymakFood = '/voucher/voucher-aymak-food',
  helpVoucher = '/voucher/help',

  employee = '/cabinet/employee',
  registry = '/cabinet/registry',
  reports = '/cabinet/reports',
  aymakFinanceFood = '/cabinet/aymak-finance-food',
  aymakFinanceOrganization = '/cabinet/aymak-finance-organization',
  aymakFinanceChildrenVouchers = '/cabinet/aymak-finance-children-vouchers',
  control = '/cabinet/control',
  voucherAgreements = '/voucher/agreements',
  adminRegistry = '/cabinet/adminRegistry',
  adminRegistryDistrict = '/cabinet/adminRegistry/:id',
  registryInfo = '/cabinet/registry/:id',
  adminOrganization = '/cabinet/admin/organization',
  adminOrganizationAdd = '/cabinet/admin/organization-add',
  adminOrganizationDetail = '/cabinet/admin/organization/:id',
  adminOrganizationEdit = '/cabinet/admin/organization/:id/edit',
  adminParentPasswordRecovery = '/cabinet/admin/parent/password-recovery',
  adminAccelerator = '/cabinet/admin/accelerator',
  adminChildApplicationSearch = '/cabinet/admin/child-applications',

  bishkekVoucher = '/bishkek/voucher',
  bishkekHelp = '/bishkek/help',

  feedback = '/feedback',
  instructions = '/instructions',
  adminInstructions = '/admin-instructions',
  settings = '/cabinet/settings',
  help = '/cabinet/help',
  privacyPolicy = '/cabinet/privacyPolicy',
  manual = '/cabinet/manual',

  notFound = '/not-found',
  preSchool = '/preschool',
}
